import Head from 'next/head'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { Row, Col } from 'antd'
import { setDashboardTitle } from '../../../redux/themeSlice'

import Layout from '../../../components/layout-components/dashboardLayout/Layout'
import Bolt from '../../../components/svgs/Bolt'
import Flame from '../../../components/svgs/Flame'
import { useEffect } from 'react'

const LuceEGas = () => {
  const { push } = useRouter()
  const dispatch = useDispatch()
  
  useEffect(() => {
    dispatch(setDashboardTitle('luce e gas servizi'))
  }, [dispatch])

  return (
    <>
      <Head>
        <title>Smartcaf | luce e gas</title>
        <link rel='icon' href='/favicon.ico' />
        <meta
          name='description'
          content='Evita le code, siamo il primo CAF in Italia completamente online!'
        />
      </Head>

      <div className='px-16 md:px-34 py-16 md:py-32'>
        <Row gutter={[24, 24]}>
          <Col>
            <div
              className='text-center shadow-lg rounded-lg p-32 w-[16.5rem] h-full relative cursor-pointer'
              onClick={() => push('/dashboard/utenze-casa/luce-e-gas-modulo')}
            >
              <div className='flex flex-col items-center justify-end h-full'>
                <div className='flex justify-center gap-8'>
                  <div className='bg-green_100 rounded-lg w-64 h-64 flex items-center justify-center'>
                    <Bolt style='w-24 h-24' />
                  </div>
                  <div className='bg-green_100 rounded-lg w-64 h-64 flex items-center justify-center'>
                    <Flame style='w-24 h-24' />
                  </div>
                </div>
                <h4 className='text-base font-bold mt-24 mb-0'>luce e gas</h4>
              </div>
              <span className='bg-green text-white text-xs font-bold rounded-md py-4 px-8 absolute top-16 right-16'>
                Nuovo
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}

LuceEGas.Layout = Layout
export default LuceEGas
